import { createEvent, createStore } from 'effector'

export const setIsDropping = createEvent<boolean>('set if file dropping')

export const $isFileDropping = createStore(false).on(
  setIsDropping,
  (_, value) => value,
)
